import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import ItemConsumptionList from "../../items/item-consumption-list";
import { fetchReportItems, updateReportItem, deleteReportItem } from "../../../../api/service/report";
import { updateReportAsync } from "../../../../slices/service/reports";

/**
 * Report-specific wrapper for ItemConsumptionList
 * This component uses the generic ItemConsumptionList component
 * (`moduleType="report"`). The list table includes salgspris and rabatt/påslag columns for reports.
 */
const ReportItemConsumptionList = ({
  items: initialItems = [],
  onItemsChange,
  disabled = false,
  report,
  onSaveItem,
  onReportUpdate,
  onItemsUpdate,
  onSubDialogStateChange,
}) => {
  const dispatch = useDispatch();

  // Wrapper function to fetch report items - memoized to prevent infinite fetch loops when used in useEffect deps
  const fetchItems = useCallback(async (reportId) => {
    return await fetchReportItems(reportId);
  }, []);

  // Wrapper function to update a single report item
  const updateItem = async (reportId, item) => {
    return await updateReportItem(reportId, item);
  };

  // Wrapper function to add report items (for bulk operations)
  const addItems = async (reportId, items) => {
    // For reports, we use updateReportAsync with all items
    const reportData = {
      id: reportId,
      items: items.map((item) => ({
        id: item.id,
        product_id: item.product_id,
        quantity: item.quantity,
        unit_id: item.unit_id,
        sales_price: item.sales_price,
        purchase_price: item.purchase_price,
        description: item.description,
        discount: item.discount || 0,
        surcharge: item.surcharge || 0,
        picked: item.picked,
        picked_at: item.picked_at,
        taken_in_vehicle: item.taken_in_vehicle,
        returned_to_storage: item.returned_to_storage,
        left_in_vehicle: item.left_in_vehicle,
        storage_id: item.storage_id,
        invoiced: item.invoiced,
      })),
    };
    return await dispatch(updateReportAsync(reportData)).unwrap();
  };

  // Wrapper function to delete a report item
  const deleteItem = async (reportId, itemId) => {
    return await deleteReportItem(reportId, itemId);
  };

  // Wrapper function to update the report (for bulk operations)
  const updateModule = async (reportData) => {
    return await dispatch(updateReportAsync(reportData)).unwrap();
  };

  return (
    <ItemConsumptionList
      items={initialItems}
      onItemsChange={onItemsChange}
      disabled={disabled}
      module={report}
      moduleType="report"
      fetchItems={fetchItems}
      updateItem={updateItem}
      addItems={addItems}
      deleteItem={deleteItem}
      updateModule={updateModule}
      onModuleUpdate={onReportUpdate}
      onItemsUpdate={onItemsUpdate}
      onSubDialogStateChange={onSubDialogStateChange}
    />
  );
};

export default ReportItemConsumptionList;
